/* eslint-disable max-len */
import { IconProps } from './types';

export const OpenAnswerQuestionIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 47.374 48.293'>
    <path
      d='M45.775,4.5H8.34C5.7,4.5,4.5,6.659,4.5,9.3V50.574L12.179,42.9h33.6a4.813,4.813,0,0,0,4.8-4.8V9.3A4.813,4.813,0,0,0,45.775,4.5ZM20.626,25.857H16.019v-4.8h4.607Zm9.215,0H25.233v-4.8h4.607Zm9.215,0H34.448v-4.8h4.607Z'
      transform='translate(-3.85 -3.85)'
      fill='none'
      stroke='#fff'
      strokeWidth='1.3'
      {...props}
    />
  </svg>
);

export const MultipleChoiceQuestionIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.756 62.756'>
    <g id='Gruppe_177' data-name='Gruppe 177' transform='translate(-1033.122 -534.309)'>
      <g transform='translate(1029.747 530.934)'>
        <path
          d='M19.062,12.984l-.709-.729a.152.152,0,0,0-.113-.048h0a.146.146,0,0,0-.113.048L13.214,17.2l-1.788-1.788a.156.156,0,0,0-.226,0l-.717.717a.16.16,0,0,0,0,.23l2.256,2.256a.713.713,0,0,0,.471.23.747.747,0,0,0,.467-.222h0l5.385-5.413A.172.172,0,0,0,19.062,12.984Z'
          transform='translate(-3.015 -3.772)'
          fill='#fff'
          {...props}
        />
        <path
          d='M11.753,4.5A7.247,7.247,0,1,1,6.625,6.625,7.2,7.2,0,0,1,11.753,4.5m0-1.128a8.378,8.378,0,1,0,8.378,8.378,8.377,8.377,0,0,0-8.378-8.378Z'
          fill='#fff'
          {...props}
        />
      </g>
      <g transform='translate(1029.747 553.934)'>
        <path
          d='M11.753,4.5A7.247,7.247,0,1,1,6.625,6.625,7.2,7.2,0,0,1,11.753,4.5m0-1.128a8.378,8.378,0,1,0,8.378,8.378,8.377,8.377,0,0,0-8.378-8.378Z'
          fill='#fff'
          {...props}
        />
      </g>
      <g transform='translate(1029.747 576.934)'>
        <path
          d='M19.062,12.984l-.709-.729a.152.152,0,0,0-.113-.048h0a.146.146,0,0,0-.113.048L13.214,17.2l-1.788-1.788a.156.156,0,0,0-.226,0l-.717.717a.16.16,0,0,0,0,.23l2.256,2.256a.713.713,0,0,0,.471.23.747.747,0,0,0,.467-.222h0l5.385-5.413A.172.172,0,0,0,19.062,12.984Z'
          transform='translate(-3.015 -3.772)'
          fill='#fff'
          {...props}
        />
        <path
          d='M11.753,4.5A7.247,7.247,0,1,1,6.625,6.625,7.2,7.2,0,0,1,11.753,4.5m0-1.128a8.378,8.378,0,1,0,8.378,8.378,8.377,8.377,0,0,0-8.378-8.378Z'
          fill='#fff'
          {...props}
        />
      </g>
    </g>
  </svg>
);
